export default "__VITE_ASSET__26399dbb__"